"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageReadPartMissingError = void 0;
exports.assertPagePartsLoaded = assertPagePartsLoaded;
exports.pageReadSource = pageReadSource;
exports.readPage = readPage;
const page_document_maps_1 = require("./page-document-maps");
const page_part_directory_1 = require("./page-part-directory");
const page_structure_entry_1 = require("./page-structure-entry");
const page_structure_tree_1 = require("./page-structure-tree");
const page_structure_writer_1 = require("./page-structure-writer");
/** A part an entry of the page names is not loaded for reading. */
class PageReadPartMissingError extends Error {
    constructor(partId) {
        super(`Page part ${partId} is not loaded for reading`);
        this.partId = partId;
        this.name = 'PageReadPartMissingError';
    }
}
exports.PageReadPartMissingError = PageReadPartMissingError;
/** Throws for the parts of the page directory that are not loaded. */
function assertPagePartsLoaded(head, loadedIds) {
    const loaded = new Set(loadedIds);
    const missing = [...(0, page_part_directory_1.readPagePartDirectory)(head).keys()].filter(id => id !== page_document_maps_1.PAGE_DOCUMENT_PART_ID && !loaded.has(id));
    if (missing.length)
        throw Object.assign(new PageReadPartMissingError(missing[0]), {
            partIds: missing,
        });
}
/** Reads `head` with the loaded part documents `parts` by part id. */
function pageReadSource(head, parts = new Map()) {
    return {
        head,
        loadedPartIds: () => [...new Set([page_document_maps_1.PAGE_DOCUMENT_PART_ID, ...parts.keys()])],
        part: partId => {
            const doc = parts.get(partId);
            if (!doc)
                throw new PageReadPartMissingError(partId);
            return doc;
        },
    };
}
/** Decodes the structure of `source` once; fields load from their parts. */
function readPage(source) {
    const docOf = (partId) => partId === page_document_maps_1.PAGE_DOCUMENT_PART_ID ? source.head : source.part(partId);
    const entries = (0, page_structure_writer_1.readPageDocsEntries)({
        head: source.head,
        loadedPartIds: () => source.loadedPartIds(),
        createPart: () => {
            throw new Error('A page read cannot create parts');
        },
        partStructure: id => (0, page_document_maps_1.pageStructureMap)(docOf(id)),
        partBlocks: id => (0, page_document_maps_1.pagePartBlocksMap)(docOf(id)),
        partElements: id => (0, page_document_maps_1.pagePartElementsMap)(docOf(id)),
    });
    const fields = (element) => ({
        get: id => {
            const entry = entries.get(id);
            if (!entry || (0, page_structure_entry_1.isPageElementKind)(entry.k) !== element)
                return undefined;
            const doc = docOf(entry.s);
            return element
                ? (0, page_document_maps_1.pagePartElementsMap)(doc).get(id)
                : (0, page_document_maps_1.pagePartBlocksMap)(doc).get(id);
        },
    });
    return {
        entries,
        tree: (0, page_structure_tree_1.derivePageTree)(entries),
        blocks: fields(false),
        elements: fields(true),
    };
}
